var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircularKpi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.004,
    height: 78,
    viewBox: "0 0 78.004 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74812",
    "data-name": "Group 74812",
    transform: "translate(24420.264 -12542)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6572",
    "data-name": "Ellipse 6572",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(-24405 12557)",
    fill: "#d3d3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73495",
    "data-name": "Path 73495",
    d: "M11.168-20A39,39,0,1,1-11.756,50.552l9.17-12.621A23.4,23.4,0,1,0,11.168-4.4Z",
    transform: "translate(-24392.432 12562)",
    fill: "#38d39a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73496",
    "data-name": "Path 73496",
    d: "M-3.923,46.923a39,39,0,0,1,0-63.1L5.246-3.56a23.4,23.4,0,0,0,0,37.862Z",
    transform: "translate(-24400.264 12565.629)",
    fill: "#f8475e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73497",
    "data-name": "Path 73497",
    d: "M-11.756-12.552A39,39,0,0,1,11.168-20V-4.4A23.4,23.4,0,0,0-2.586.069Z",
    transform: "translate(-24392.432 12562)",
    fill: "#fdc072"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74811",
    "data-name": "Group 74811",
    transform: "translate(-24389.609 12587.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74802",
    "data-name": "Group 74802",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73458",
    "data-name": "Path 73458",
    d: "M43.734,66.1v2.255a2.88,2.88,0,0,1-1.153,2.255,2.865,2.865,0,0,1,1.153,2.255V75.12a.973.973,0,0,1-1.922,0V72.865A1.582,1.582,0,0,0,40.13,71.43H38.448V75.12a.973.973,0,0,1-1.922,0V70.609h0V66.1a.973.973,0,0,1,1.922,0v3.691H40.13a1.582,1.582,0,0,0,1.682-1.435V66.1a.973.973,0,0,1,1.922,0Zm14.9,9.842a.9.9,0,0,0,.961-.82V66.1a.973.973,0,0,0-1.922,0V75.12A.9.9,0,0,0,58.631,75.94Zm-4.325-7.586a3.371,3.371,0,0,1-3.6,3.075H49.02V75.12a.973.973,0,0,1-1.922,0V66.1a.9.9,0,0,1,.961-.82H50.7A3.371,3.371,0,0,1,54.306,68.354Zm-1.922,0A1.582,1.582,0,0,0,50.7,66.919H49.02v2.87H50.7A1.582,1.582,0,0,0,52.384,68.354Z",
    transform: "translate(-40.526 -65.279)",
    fill: "#4677d4",
    stroke: "#4677d4",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(-24388.844 12562.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73469",
    "data-name": "Path 73469",
    d: "M11.462,29.249,5.916,23.772A1.456,1.456,0,0,1,5.778,21.9a1.317,1.317,0,0,1,2.08-.139l4.575,4.575,16.36-16.36a1.386,1.386,0,0,1,1.941,1.941L13.4,29.249a1.317,1.317,0,0,1-1.941,0Z",
    transform: "translate(-5.501 -9.7)",
    fill: "#4677d4",
    stroke: "#4677d4",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularKpi);
export default __webpack_public_path__ + "static/media/circular-kpi.4bf6932cebbb187a330d4817eb67c66a.svg";
export { ForwardRef as ReactComponent };